<template>
    <div>
        <div class="content-header">
            <h3>查询</h3>
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                <el-form-item label="名称">
                    <el-input v-model="formInline.freeName" placeholder="名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select :popper-append-to-body="true" clearable  v-model="formInline.status">
                        <el-option
                                v-for="item in queryStatusList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList">查询</el-button>
                    <el-button type="success" @click="handleAdd">新增</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-wrap">
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="freeId" label="标志"></el-table-column>
                <el-table-column prop="freeName" label="名称"></el-table-column>
                <el-table-column prop="beginTime" label="开始日期"></el-table-column>
                <el-table-column prop="endTime" label="结束日期"></el-table-column>
                <el-table-column prop="status" :formatter="convertStatus" label="状态" sortable></el-table-column>
                <el-table-column prop="freePrice" label="价格" sortable></el-table-column>
                <el-table-column prop="freePrice" label="类型" sortable>
                    <template slot-scope="scope">
                        <span>{{scope.row.freePrice>0 ? '换购' : '赠品'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="platformGroupName" label="所属公司" sortable></el-table-column>
                <el-table-column prop="createTime" label="创建日期"></el-table-column>
                <el-table-column label="操作" fixed="right" width="230">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="warning " size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="预览" :visible.sync="showPreviewDialog" v-if="showPreviewDialog" width="50%">
            <Preview :linkType="this.linkType" :activeType="this.activeType" :params="this.params"></Preview>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getFreeList,
        getFreeProductList,
        getFreeRuleList,
        saveOrUpdateFree,
        saveOrUpdateFreeProduct,
        saveOrUpdateFreeRule,
        deleteFreeProduct,
        deleteFreeRule,
        getGroupListL,
        getProductListL,
        getSalesTypeList,
        getCityList,
        getPromotionList,
        getFreeTypeList,
        getVipAllList,
        getEnableCashticketListApi,
        getActivePromotionsByActiveType,
        getConfigSalesTypeList,
        getItems, getActiveForOption
    } from '../../api/api';
    import Preview from "../../components/Preview";

    //定义组件
    export default {
        data() {
            return {
                linkType:0,
                activeType:null,
                params:{},
                showPreviewDialog:false,
                dataList: [],
                dataList1: [],
                dataList2: [],
                itemTypeData:[],
                getProductList:[],
                productList:[],
                getPromotionList:[],
                getGroupList:[],
                getFreeTypeList:[],
                getSalesTypeList:[],
                getCityList:[],
                getVipAllList:[],
                getCouponList:[],
                getPrepayCardList:[],
                getActiveAllList:[],
                statusList: [{value: 1, name: '上线'}, {value: 0, name: '不上线'}],
                queryStatusList: [{value: -1, name: '全部'},{value: 1, name: '上线'}, {value: 0, name: '不上线'}],
                loading: true,

                dialogFormVisible: false,

                formInline: {
                    freeName: "",
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    status:-1
                },

            }
        },
        //挂载时候执行
        mounted() {
            this.getList();
        },
        methods: {
            //定义查询方法
            getList() {
                this.loading = true;
                getFreeList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.dataList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },

            convertStatus(row, column, cellValue) {
                if (row.status == 1) {
                    return "上线";
                } else {
                    return "下线";
                }
            },
            handleAdd(){
                this.$router.push({path:'/free/detail/:id',name: 'freeEdit',params:{id:''}})
            },
            handleUpdate(row){
                this.$router.push({path:'/free/detail/:id',name: 'freeEdit',params:{id:row.freeId}})
            },
            handlePreActive(row){
                this.activeType=11;
                this.params={bindCode:row.activeNo};
                console.log(row.activeNo);
                this.showPreviewDialog=true;
            },

        },
        components:{
            Preview
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/sales/free.vue